import type { App, Plugin } from 'vue'

import type { UiKitConfig } from '@ui/composables/useUiKitConfig'
import { UI_KIT_CONFIG_KEY } from '@ui/composables/useUiKitConfig'

export function createUiKit({ messages, linkComponent, navigate, imageFallback }: UiKitConfig = {}): Plugin {
  return {
    install(app: App) {
      app.provide(UI_KIT_CONFIG_KEY, { messages, linkComponent, navigate, imageFallback })
    },
  }
}
